import { FC } from 'react';
import { ListItemComponentProps } from './ListItemComponent';
import { ListItemComponent } from '../index';

export type ListComponentProps = {
  className?: string;
  listItems: ListItemComponentProps[];
};

const ListComponent: FC<ListComponentProps> = ({
  className = '',
  listItems,
}) => {
  return (
    <div className={`flex flex-col w-full px-0 md:px-6 ${className}`}>
      {listItems.map((item, idx) => (
        <ListItemComponent {...item} key={idx} />
      ))}
    </div>
  );
};

export default ListComponent;
